import SharedEvaluationNodesPage from 'pages/mobile/Finance/shared/EvaluationNodesPage';
import React from 'react';

const ConfirmingEvaluationNodesPage: React.FC = () => (
  <SharedEvaluationNodesPage product="confirming" />
);

export default ConfirmingEvaluationNodesPage;
